export default __webpack_public_path__ + "static/catto-70626c6fbacb53aaafc396e5ba8581b2.png";